import type { Difficulty } from '../config/difficulty';

const STORAGE_KEY = 'spliffo:high-scores:v1';

export interface DifficultyHighScores {
  longestSingleDrag: number;
  longestMatchTotal: number;
  matchesWon: number;
  matchesPlayed: number;
}

export type HighScoreMap = Record<Difficulty, DifficultyHighScores>;

const defaultScores = (): HighScoreMap => ({
  easy: { longestSingleDrag: 0, longestMatchTotal: 0, matchesWon: 0, matchesPlayed: 0 },
  medium: { longestSingleDrag: 0, longestMatchTotal: 0, matchesWon: 0, matchesPlayed: 0 },
  hard: { longestSingleDrag: 0, longestMatchTotal: 0, matchesWon: 0, matchesPlayed: 0 },
  narco: { longestSingleDrag: 0, longestMatchTotal: 0, matchesWon: 0, matchesPlayed: 0 }
});

export class HighScoreStore {
  static read(): HighScoreMap {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      if (!raw) return defaultScores();
      const parsed = JSON.parse(raw) as Partial<HighScoreMap>;
      const base = defaultScores();
      return {
        easy: { ...base.easy, ...parsed.easy },
        medium: { ...base.medium, ...parsed.medium },
        hard: { ...base.hard, ...parsed.hard },
        narco: { ...base.narco, ...parsed.narco }
      };
    } catch {
      return defaultScores();
    }
  }

  static write(scores: HighScoreMap): void {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(scores));
    } catch {
      // ignore quota / unavailable storage
    }
  }

  static recordMatch(
    difficulty: Difficulty,
    playerWon: boolean,
    matchTotal: number,
    longestSingleDrag: number
  ): HighScoreMap {
    const all = HighScoreStore.read();
    const entry = all[difficulty];
    entry.matchesPlayed += 1;
    if (playerWon) entry.matchesWon += 1;
    if (matchTotal > entry.longestMatchTotal) entry.longestMatchTotal = matchTotal;
    if (longestSingleDrag > entry.longestSingleDrag) entry.longestSingleDrag = longestSingleDrag;
    HighScoreStore.write(all);
    return all;
  }
}
